module.exports = __webpack_public_path__ + "img/model_23_ug.fa4f68fc.jpg";